import { get, includes, isNil, keys, map } from 'lodash'

import { mergeArrayOfObjects } from '../../core/utils'

import { flattenTreeStructure } from '../../common/utils'

import transformListToTree from './transform-list-to-tree'

const updateCheckedKeywordsLanguageOnKeywordTrees = (
  keywordsState,
  languageId,
) =>
  mergeArrayOfObjects(
    map(keys(keywordsState.data), keywordType => {
      const flatKeywordsTree = flattenTreeStructure(
        get(keywordsState.data, keywordType),
      )

      const keywordsWithChangedLanguage = map(flatKeywordsTree, node => {
        const shouldUpdateLanguage = includes(
          get(keywordsState.checkedKeywordKeys, keywordType),
          node.key,
        )

        if (!shouldUpdateLanguage || node.isSubtype || isNil(node.parentId)) {
          return node
        }

        if (node.isName) {
          throw new Error('Should not assign language to ingredient name')
        }

        return { ...node, isModified: true, languageId }
      })

      return { [keywordType]: transformListToTree(keywordsWithChangedLanguage) }
    }),
  )

export default updateCheckedKeywordsLanguageOnKeywordTrees
